/*
 * TEMPORARY WORKAROUND (CLIENTE-5139).
 *
 * Some plans exist only for internal testing and are identified by "teste" in
 * their coupon code. There is no flag for it in the contract yet, so the
 * backoffice filters them out on the client. Delete this module — and the
 * filter in `_store/index.js` — once the backend can mark them properly.
 */

const INTERNAL_CODE_MARKER = 'teste';

const couponCodes = (benefits,) => {
  return (benefits || []).
    filter((benefit,) => benefit &&
      benefit.coupon_package &&
      benefit.coupon_package.coupon,).
    map((benefit,) => benefit.coupon_package.coupon.code,).
    filter((code,) => typeof code === 'string',);
};

/**
 * Whether a plan is internal-only and must be hidden from the listings.
 *
 * Looks at every coupon package in both `benefits` and `trial_benefits`, not
 * just the one the screen displays: a plan carrying a test coupon anywhere is
 * a test plan. That covers every code a plan can carry — the other benefit
 * type, `generated_coupon`, holds only an `id`.
 *
 * @param {Object} rawPlan plan as returned by the BFF, before normalization
 * @returns {Boolean}
 */
export const isInternalTestPlan = (rawPlan,) => {
  const { benefits, trial_benefits, } = rawPlan || {};

  return couponCodes(benefits,).
    concat(couponCodes(trial_benefits,),).
    some((code,) => code.toLowerCase().includes(INTERNAL_CODE_MARKER,),);
};

export default isInternalTestPlan;
